<template>
    <validation-observer ref="loginValidation" #default="{ invalid }">
        <b-form class="auth-login-form mt-2" @submit.prevent>

            <!-- email -->
            <b-form-group label-for="email" label="Email">
                <validation-provider #default="{ errors }" name="Email" rules="required|email">
                    <b-form-input id="email" v-model="userEmail" name="login-email"
                        :state="errors.length > 0 ? false : null" placeholder="Email" />
                    <small class="text-danger">
                        {{ errors[0] }}
                    </small>
                </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group>
                <div class="d-flex justify-content-between">
                    <label for="password">
                        Password
                    </label>
                    <b-link :to="{ name: 'auth-forgot-password' }">
                        <small>
                            Forgot Password?
                        </small>
                    </b-link>
                </div>
                <validation-provider #default="{ errors }" name="Password" rules="required">
                    <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                        <b-form-input id="password" v-model="password" :type="passwordFieldType" class="form-control-merge"
                            :state="errors.length > 0 ? false : null" name="login-password" placeholder="Password" />

                        <b-input-group-append is-text>
                            <feather-icon class="cursor-pointer" :icon="passwordToggleIcon"
                                @click="togglePasswordVisibility" />
                        </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">
                        {{ errors[0] }}
                    </small>
                </validation-provider>
            </b-form-group>
            <!-- checkbox -->
            <b-form-group>
                <div class="d-flex justify-content-between">
                    <b-form-checkbox id="remember-me" v-model="isSavedEmail" name="checkbox-1">
                        Remember Me
                    </b-form-checkbox>
                    <b-form-select v-model="locale" :options="locales" size="sm" style="width:100px" />
                </div>
            </b-form-group>
            <!-- submit button -->
            <b-button variant="primary" type="submit" block :disabled="invalid || submitted" @click="validationForm">
                Sign in
            </b-button>
        </b-form>
    </validation-observer>
</template>
<script>
import { ref, computed, getCurrentInstance, watch } from '@vue/composition-api'

import useEnvString from '@/composables/useEnvString'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import utils from '@/auth/utils'
export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const isSavedEmail = ref(!!localStorage.getItem('save-id'))
        const userEmail = ref(localStorage.getItem('save-id') || '')
        const password = ref('')
        const passwordFieldType = ref('password')
        const needOtpLogin = ref(false)
        const submitted = ref(false)
        const locale = ref(localStorage.getItem('locale'))
        const locales = [
            {
                value: 'ko',
                img: require('@/assets/images/flags/ko.png'),
                text: '한국어'
            },
            {
                value: 'en',
                img: require('@/assets/images/flags/en.png'),
                text: 'English'
            },
            {
                value: 'ja',
                img: require('@/assets/images/flags/ja.png'),
                text: '日本語'
            }
        ]
        const { VUE_APP_COMMON_LOGIN } = useEnvString()
        const isCommonLogin = computed(() => VUE_APP_COMMON_LOGIN === 'TRUE')
        const passwordToggleIcon = computed(() => passwordFieldType.value === 'password' ? 'EyeIcon' : 'EyeOffIcon')

        const togglePasswordVisibility = () => {
            passwordFieldType.value = passwordFieldType.value === 'password' ? 'text' : 'password'
        }
        const validationForm = () => {
            vm.$refs.loginValidation.validate().then(success => {
                submitted.value = true
                if (success) {
                    store.dispatch('createMemberAuth', {
                        email: userEmail.value,
                        password: password.value
                    }).then(response => {
                        if (isSavedEmail.value) {
                            localStorage.setItem('save-id', userEmail.value)
                        }
                        needOtpLogin.value = response.needOtpLogin
                        if (!needOtpLogin.value) {
                            localStorage.setItem('x-auth-token', response.token)
                            let nextPath = utils.getRouteForLoggedInUser()
                            utils.isUserMonths().then(haveBilingData => {
                                if (!haveBilingData) {
                                    nextPath = { name: 'infomation' }
                                }
                                if (utils.isTcPopsLogin()) {
                                    nextPath = { name: 'agreement' }
                                }
                                vm.$router.push(nextPath)
                            })
                        } else {
                            context.emit('auth:otp')
                        }
                        submitted.value = false
                    }).catch(error => {
                        console.error(error)
                        isSavedEmail.value = false
                        submitted.value = false
                        vm.$refs.loginValidation.setErrors(error?.response?.data ?? '')
                    })
                }
            })
        }

        /* watch */
        watch(locale, (value) => {
            vm.$i18n.locale = value || 'en'
            localStorage.setItem('locale', value || 'en')
        })
        watch(isSavedEmail, (value) => {
            if (!value) {
                localStorage.removeItem('save-id')
            }
        })
        return {
            required,
            email,
            userEmail,
            password,
            locale,
            locales,
            isSavedEmail,
            submitted,
            isCommonLogin,
            passwordToggleIcon,
            passwordFieldType,
            validationForm,
            togglePasswordVisibility
        }
    }
}
</script>
